import React, { useState } from "react";
//@ts-ignore
import { LanguageContext } from "../../../../context/LanguageContext.jsx";
//@ts-ignore
import { dataList } from "../../AdmMain.jsx";
import Page from "../../../Atomic/template/PageTable";
import SubNavi from "../../../Atomic/molecules/SubNavi";
import { useNavigate } from "react-router-dom";
//@ts-ignore
import TableAtom from "../../../Atomic/organism/AtomTable";

export default function LogTable() {
  //@ts-ignore
  const { language } = React.useContext(LanguageContext);
  const navi = useNavigate();
  const [data, setData] = useState<any>([
    {
      id: 'iotadm0',
      auth: '위치정보관리자 책임자',
      status: '사용중',
      ip: '106.247.85.10',
      memo: '권한 변경',
      makedate: '2021-06-07 17:40:05',
      deldate: '-'
    },
    {
      id: 'iotadm1',
      auth: '위치정보 취급자',
      status: '사용중',
      ip: '106.247.85.10',
      memo: '-',
      makedate: '2021-08-09 14:38:05',
      deldate: '-'
    },
    {
      id: 'iotadm2',
      auth: '위치정보 취급자',
      status: '사용중',
      ip: '106.247.85.10',
      memo: '-',
      makedate: '2022-03-16 13:42:09',
      deldate: '-'
    },
    {
        id: 'iotbiz',
        auth: '위치정보 취급자',
        status: '사용중',
        ip: '106.247.85.10',
        memo: '-',
        makedate: '2023-04-06 11:56:08',
        deldate: '-'
    },
    {
      id: 'iotadm00',
      auth: '위치정보 취급자',
      status: '말소',
      ip: '106.247.85.10',
      memo: '퇴사로 인한 말소',
      makedate: '2022-03-21 16:30:32',
      deldate: '2022-08-16 13:52:11'
    },
    {
      id: 'iotadm',
      auth: '위치정보 취급자',
      status: '말소',
      ip: '106.247.85.10',
      memo: '퇴사로 인한 말소',
      makedate: '2022-06-07 17:39:05',
      deldate: '2023-04-03 17:40:55'
    },
    {
      id: 'twkang',
      auth: '위치정보 취급자',
      status: '말소',
      ip: '106.247.85.10',
      memo: '퇴사로 인한 말소',
      makedate: '2022-08-08 15:03:18',
      deldate: '2022-09-19 15:07:25'
    },
  ]);
  const [subNavi, setSubNavi] = useState<any>([
    {
      path: "/Adm/mng-access",
      labelKR: "접근권한 정보",
      labelEN: "Auth of Acess Info.",
    },
    {
      path: "/Adm/access-log",
      labelKR: "관리자 접근권한",
      labelEN: "Access Auth of Admin",
    },
  ]);

  function translate(kr: string, en: string) {
    return language === "KOR" ? kr : en;
  }

  const columns: any = [
    {
        header: language === "KOR" ? "번호" : "Num",
        name: "rowKey" + 1,
        width: 70,
        align: "center",
        formatter: (name: any) => name.row.rowKey + 1,
    },
    {
      header: translate("ID", "ID"),
      name: "id",
      align: "center",
    },
    {
      header: translate("권한", "Auth"),
      name: "auth",
      align: "center",
    },
    {
      header: translate("상태", "Status"),
      name: "status",
      align: "center",
      formatter: (e: any) => e?.value === '말소' ? `<span style='color:red'>말소</span>` : '사용중'
    },
    {
      header: translate("IP", "IP"),
      name: "ip",
      align: "center",
    },
    {
      header: translate("비고", "Memo"),
      name: "memo",
      align: "center",
    },
    {
      header: translate("등록일", "makeate"),
      name: "makedate",
      align: "center",
    },
    {
      header: translate("말소일", "deldate"),
      name: "deldate",
      align: "center",
    },
  ];

  return (
    <>
      <Page
        language={language}
        dataList={dataList}
        title={`${language === "KOR" ? "관리자 접근권한" : "Access Auth of Admin"}`}
        menu="/Adm/mng-access"
      >
        <SubNavi
          subDataList={subNavi}
          language={language}
          navi={navi}
          classPath="/Adm/access-log"
        />
        <TableAtom data={data} columns={columns} />
      </Page>
    </>
  );
}
